<script setup lang="ts">
import { computed } from "vue";
const props = defineProps<{
	make?: string | null;
	size?: "xs" | "sm" | "lg" | "md" | "xl" | "2xl" | "3xl";
}>();

const cleanMake = computed(() => {
	const remap: Record<string, string> = {
		"md helicopters": "md",
	};
	const lowered = props.make?.toLowerCase() || "?";
	const cleaned = lowered.replaceAll("'", "");
	return remap[cleaned] ?? cleaned;
});
const avatarSrc = computed(() => {
	const pngBrands = new Set([
		"bristell",
		"dassault",
		"robinson",
		"eclipse",
		"piaggio",
		"hawker",
		"lear",
		"sikorsky",
		"schweizer",
		"vans",
	]);
	
	if (pngBrands.has(cleanMake.value)) {
		return `/brands/${cleanMake.value}.png`;
	}
	return `/brands/${cleanMake.value}.jpeg`;
});

</script>

<template>
  <UAvatar
    :src="avatarSrc"
    :alt="cleanMake.toUpperCase()"
    :size="size"
  />
</template>